module.exports = __webpack_public_path__ + "static/media/mask-white.b53ecb10.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/mask-white.png
// module id = 127
// module chunks = 0